import React from 'react'
import Heading from 'LuxKit/Typography/Heading'
import moment from 'moment'
import { TOUR_ASIA_CAMPAIGN, TOUR_V2_SEARCH_HERO_IMAGE_ASIA_CAMPAIGN } from 'constants/tours'
import TourAsiaCampaignTakeoverBackground from 'components/Common/SiteTakeover/TourAsiaCampaignTakeoverBackground'

const TourBestAsiaPromoTakeover: App.SiteTakeover = {
  id: 'tourbestasia',
  startDate: moment('2025-03-17T09:00:00+1100'),
  endDate: moment('2025-04-28T23:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: new Set(['AU', 'NZ', 'US', 'GB', 'FR', 'IT', 'ES', 'NL', 'DE', 'IE', 'CA']),
  offerTypes: new Set(['direct_tour']),
  verticals: new Set(['tours']),
  campaignTags: new Set([TOUR_ASIA_CAMPAIGN]),
  imageId: TOUR_V2_SEARCH_HERO_IMAGE_ASIA_CAMPAIGN,
  palette: 'inverse',
  primaryColour: '',
  heroCarousel: {
    title: <Heading variant="heading2"><i>Explore</i> the best of Asia</Heading>,
    palette: 'inverse',
    verticals: ['tours'],
  },
  backgroundElement: TourAsiaCampaignTakeoverBackground,
}

export default TourBestAsiaPromoTakeover
